import { ChangeDetectionStrategy, Component, computed, input, model, output } from '@angular/core';
import { AgentBioUpdateDto, AgentProfileDto } from '@workspace/data-types';
import { AuraEditWrapperComponent } from '@workspace/ng-aura';
import { AgentBioDisplayComponent } from '../display/agent-bio-display.component';
import { AgentBioFormComponent } from '../form/agent-bio-form.component';

@Component({
  selector: 'etxe-agent-bio-edit',
  imports: [AuraEditWrapperComponent, AgentBioFormComponent, AgentBioDisplayComponent],
  templateUrl: './agent-bio-edit.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgentBioEditComponent {
  readonly initialProfile = input<AgentProfileDto | null>(null);
  readonly initialBio = input<string | undefined>(undefined);
  readonly isEditing = model<boolean>(false);
  readonly isAllowedToEdit = input<boolean>(true);

  readonly saved = output<AgentBioUpdateDto>();
  readonly profileSaved = output<AgentProfileDto>();

  readonly currentBio = computed(() => {
    return this.initialBio() ?? this.initialProfile()?.activity?.bio ?? '';
  });

  onSave(dto: AgentBioUpdateDto | null): void {
    if (!dto) return;
    this.saved.emit(dto);
    const profile = this.initialProfile();
    if (profile) {
      this.profileSaved.emit({
        ...profile,
        activity: {
          ...profile.activity,
          bio: dto.bio,
        },
      });
    }
  }
}
